/*
 * @Author: liang yuhong
 * @Date:   2018-08-17 10:39:02
 * @Last Modified by:   Ding Jianlong
 * @Last Modified time: 2018-08-17 10:39:18
 */
module.exports = {
  GetQueryString: function(name) {
    return GetQueryString(name)
  }
}
// 获得连接参数
function GetQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let search = window.location.href.split('?')[1] || ''
  let r = search.match(reg)
  if (r !== null) {
    return unescape(r[2])
  }
  return null
}


// WEBPACK FOOTER //
// ./src/plugin/tools.js